// extracted by mini-css-extract-plugin
module.exports = {"accordion":"FAQ_accordion__AUlTO","c":"FAQ_c__gaA3V","p":"FAQ_p__3Suip"};